import { API_PAYMENTS_URL } from '@/constants/config';
import { fetch } from '@/utils/fetch';

interface PaymentSummary {
  orderAmount: number;
  status: string;
  userPaymentAmount: number;
  userTipAmount: number;
  userServiceFeeAmount: number;
}

interface Params {
  orderNumber: string;
  browserUserId: string | null;
  signal: AbortSignal;
}

export const getPaymentSummary = ({
  orderNumber,
  browserUserId,
  signal,
}: Params): Promise<PaymentSummary> =>
  fetch
    .get(
      `${API_PAYMENTS_URL}/payments/summary?reference=${orderNumber}${browserUserId ? `&browserUserId=${browserUserId}` : ''}`,
      { signal }
    )
    .then(response => response.data);
